var map = {
	"./config-ncl.json": 98185,
	"./config.json": 82022,
	"./data/chat/alert_overview.json": 27172,
	"./data/chat/analyze_cpu.json": 54427,
	"./data/chat/blocked_content.json": 86746,
	"./data/chat/create_igroup.json": 50404,
	"./data/chat/create_igroup_form.json": 39058,
	"./data/chat/create_vol.json": 41576,
	"./data/chat/create_vol_classes.json": 70993,
	"./data/chat/create_vol_dynamic_form.json": 10244,
	"./data/chat/create_vol_layout_form.json": 97841,
	"./data/chat/delete_volume.json": 88387,
	"./data/chat/error_api.json": 38267,
	"./data/chat/list_volumes.json": 54725,
	"./data/chat/noisiest_cluster.json": 28881,
	"./data/chat/recommend_cluster.json": 73685,
	"./data/chat/storage_classes.json": 79755,
	"./data/chat/vol_over_85.json": 98580,
	"./data/chat/welcome.json": 27283,
	"./data/chat/workload_performance.json": 80404,
	"./data/keystone/subscriptions.json": 92071,
	"./data/keystone/verified-users.json": 78648,
	"./data/platform-ncl/add-agent-azure.json": 1952,
	"./data/platform-ncl/add-agent-gcp.json": 37405,
	"./data/platform-ncl/add-federation.json": 14288,
	"./data/platform-ncl/add-pvtjwt-key.json": 83600,
	"./data/platform-ncl/add-service-account.json": 87079,
	"./data/platform-ncl/add-storage-class.json": 22453,
	"./data/platform-ncl/add-user.json": 57647,
	"./data/platform-ncl/add-volume-ncl.json": 93366,
	"./data/platform-ncl/adservices-test-connection.json": 17005,
	"./data/platform-ncl/agent-create-azure.json": 3341,
	"./data/platform-ncl/agent-create.json": 2591,
	"./data/platform-ncl/agent-status.json": 89762,
	"./data/platform-ncl/agent-tls-certificate.json": 63030,
	"./data/platform-ncl/ai-config-id.json": 68972,
	"./data/platform-ncl/ai-config-save.json": 86292,
	"./data/platform-ncl/ai-config.json": 41309,
	"./data/platform-ncl/ai-provider-models.json": 92057,
	"./data/platform-ncl/ai-supported-models.json": 28967,
	"./data/platform-ncl/ai-supported-providers.json": 55356,
	"./data/platform-ncl/alert-detail.json": 51227,
	"./data/platform-ncl/alert-details-timeseries-forecast.json": 51047,
	"./data/platform-ncl/alert-details-timeseries-history.json": 94593,
	"./data/platform-ncl/alert-notification-policies.json": 57654,
	"./data/platform-ncl/alert-rules.json": 94408,
	"./data/platform-ncl/alert-summary.json": 2907,
	"./data/platform-ncl/alert-trends.json": 73155,
	"./data/platform-ncl/alerts-agents.json": 87804,
	"./data/platform-ncl/alerts-list-lun-drifts.json": 29268,
	"./data/platform-ncl/alerts-list-volume-drifts.json": 75147,
	"./data/platform-ncl/alerts-list.json": 77040,
	"./data/platform-ncl/alerts-related.json": 85411,
	"./data/platform-ncl/alerts-remediation-options-autogrow.json": 60589,
	"./data/platform-ncl/alerts-remediation-options-resize.json": 31407,
	"./data/platform-ncl/alerts-remediation-options.json": 52713,
	"./data/platform-ncl/alerts-remediations.json": 94833,
	"./data/platform-ncl/alerts-resource-clusteruuid.json": 39759,
	"./data/platform-ncl/all-relationships.json": 32974,
	"./data/platform-ncl/audit-options.json": 66744,
	"./data/platform-ncl/audit.json": 99120,
	"./data/platform-ncl/autonomous-engine-config.json": 10785,
	"./data/platform-ncl/autonomous-engine-policies.json": 20474,
	"./data/platform-ncl/available-update-versions.json": 31856,
	"./data/platform-ncl/aws-assume-role.json": 3982,
	"./data/platform-ncl/azure-service-principal-post.json": 54858,
	"./data/platform-ncl/back-up-and-recovery-summary.json": 67428,
	"./data/platform-ncl/billing-preferences.json": 52042,
	"./data/platform-ncl/by-capacity-byol-details-v2.json": 20508,
	"./data/platform-ncl/capacity-forecast-forecast.json": 2060,
	"./data/platform-ncl/capacity-forecast-history.json": 70941,
	"./data/platform-ncl/capacity-percent-timeseries.json": 55691,
	"./data/platform-ncl/capacity-timeseries.json": 29448,
	"./data/platform-ncl/card-template-aggregate.json": 34908,
	"./data/platform-ncl/card-template-fleet.json": 88735,
	"./data/platform-ncl/card-template-lun.json": 13268,
	"./data/platform-ncl/card-template-svm.json": 78119,
	"./data/platform-ncl/card-template-system.json": 12825,
	"./data/platform-ncl/card-template-volume.json": 18169,
	"./data/platform-ncl/case-search.json": 71131,
	"./data/platform-ncl/cbs_we_replication.json": 77797,
	"./data/platform-ncl/cbs_we_status.json": 39218,
	"./data/platform-ncl/change-cvo-package-options.json": 93269,
	"./data/platform-ncl/cifs.json": 88608,
	"./data/platform-ncl/cloud-compliance-compliance-status.json": 38576,
	"./data/platform-ncl/cloud-compliance-status.json": 28549,
	"./data/platform-ncl/cloud-providers.json": 77784,
	"./data/platform-ncl/cloud-storage.json": 9731,
	"./data/platform-ncl/cloud-sync-relationships-stats.json": 50935,
	"./data/platform-ncl/cloudmanager_cbs-v1-relationships.json": 50811,
	"./data/platform-ncl/cluster-metricsql-capacity.json": 71523,
	"./data/platform-ncl/cluster-metricsql-iops.json": 60477,
	"./data/platform-ncl/clusterRecommendation.json": 35524,
	"./data/platform-ncl/connector-about.json": 93767,
	"./data/platform-ncl/connectors.json": 25616,
	"./data/platform-ncl/console-agents-configuration.json": 5454,
	"./data/platform-ncl/create-ad-services.json": 32953,
	"./data/platform-ncl/create-fleet.json": 69231,
	"./data/platform-ncl/create-folder.json": 9557,
	"./data/platform-ncl/create-project.json": 75141,
	"./data/platform-ncl/credential.json": 60096,
	"./data/platform-ncl/credentials.json": 63148,
	"./data/platform-ncl/custom-dashboard-details.json": 66660,
	"./data/platform-ncl/custom-dashboard-list.json": 75913,
	"./data/platform-ncl/cvs-azure-accounts.json": 32608,
	"./data/platform-ncl/dashboard-security-dashboard.json": 9765,
	"./data/platform-ncl/dashboard-volume-dashboard.json": 43341,
	"./data/platform-ncl/disable-adservices.json": 96716,
	"./data/platform-ncl/discover-fsx.json": 47681,
	"./data/platform-ncl/discover-on-prem.json": 42716,
	"./data/platform-ncl/dw-associated-accounts.json": 64290,
	"./data/platform-ncl/dw-associated-subscriptions.json": 87828,
	"./data/platform-ncl/email-configuration.json": 56984,
	"./data/platform-ncl/enable-adservices.json": 7792,
	"./data/platform-ncl/external-licenses.json": 867,
	"./data/platform-ncl/feature-rollouts.json": 33153,
	"./data/platform-ncl/federation-domains-patch.json": 71076,
	"./data/platform-ncl/federation-domains-post.json": 91092,
	"./data/platform-ncl/federation-domains.json": 2920,
	"./data/platform-ncl/federation-test-connection.json": 52337,
	"./data/platform-ncl/federation-unmigratedconnections.json": 98334,
	"./data/platform-ncl/filter-audit-action-add-credentials.json": 10685,
	"./data/platform-ncl/filter-audit-action-update-license-by-serial.json": 96871,
	"./data/platform-ncl/filter-audit-action-update-we-snapMirror-policies.json": 63023,
	"./data/platform-ncl/filter-audit-auto-remediation-failed.json": 86314,
	"./data/platform-ncl/filter-audit-auto-remediation-success.json": 49989,
	"./data/platform-ncl/filter-audit-auto-remediation-triggered.json": 85949,
	"./data/platform-ncl/filter-audit-no-agent.json": 18807,
	"./data/platform-ncl/filter-audit-service-console.json": 4953,
	"./data/platform-ncl/filter-audit-service-credentials.json": 42104,
	"./data/platform-ncl/filter-audit-service-digitalwallet.json": 18425,
	"./data/platform-ncl/filter-audit-status-failed.json": 20735,
	"./data/platform-ncl/filter-audit-status-success.json": 71323,
	"./data/platform-ncl/filter-audit-user-bill.json": 9185,
	"./data/platform-ncl/filter-audit-user-sam.json": 35664,
	"./data/platform-ncl/filter-backup-licenses.json": 81875,
	"./data/platform-ncl/filter-dr-licenses.json": 94359,
	"./data/platform-ncl/filter-include-exchanged-licenses.json": 63990,
	"./data/platform-ncl/filter-org-resources-count.json": 96314,
	"./data/platform-ncl/filter-rsp-licenses.json": 68906,
	"./data/platform-ncl/filter-tiering-licenses.json": 55097,
	"./data/platform-ncl/fleet-aggregates.json": 79512,
	"./data/platform-ncl/fleet-clusters-certificateExpiryStatus.json": 56330,
	"./data/platform-ncl/fleet-clusters.json": 11730,
	"./data/platform-ncl/fleet-detail.json": 12388,
	"./data/platform-ncl/fleet-luns.json": 6435,
	"./data/platform-ncl/fleet-management-detail.json": 80466,
	"./data/platform-ncl/fleet-namespaces.json": 53821,
	"./data/platform-ncl/fleet-networkinterfaces.json": 15768,
	"./data/platform-ncl/fleet-nodes.json": 14903,
	"./data/platform-ncl/fleet-ports.json": 17844,
	"./data/platform-ncl/fleet-qtrees.json": 45698,
	"./data/platform-ncl/fleet-smbshares.json": 88479,
	"./data/platform-ncl/fleet-svms.json": 83287,
	"./data/platform-ncl/fleet-volumes.json": 30436,
	"./data/platform-ncl/fleets.json": 64800,
	"./data/platform-ncl/folder-resources-get.json": 95960,
	"./data/platform-ncl/gcp-agent-create.json": 6710,
	"./data/platform-ncl/gcp-config-deployment.json": 27609,
	"./data/platform-ncl/gcp-config-operation-status.json": 52246,
	"./data/platform-ncl/gcp-storage-buckets.json": 9092,
	"./data/platform-ncl/gcp-storage-upload-object.json": 90081,
	"./data/platform-ncl/get-ad-services.json": 66448,
	"./data/platform-ncl/get-agent.json": 66456,
	"./data/platform-ncl/get-capacity-policies.json": 16716,
	"./data/platform-ncl/get-export-policies.json": 52874,
	"./data/platform-ncl/get-igroups.json": 5791,
	"./data/platform-ncl/get-initiators.json": 18397,
	"./data/platform-ncl/get-local-tiers-by-org.json": 62525,
	"./data/platform-ncl/get-luns-by-org.json": 7358,
	"./data/platform-ncl/get-ontap-volumes.json": 83830,
	"./data/platform-ncl/get-os-types.json": 10305,
	"./data/platform-ncl/get-performance-policies.json": 80022,
	"./data/platform-ncl/get-protection-policies.json": 111,
	"./data/platform-ncl/get-pvtjwt-keys.json": 5605,
	"./data/platform-ncl/get-security-policies.json": 33169,
	"./data/platform-ncl/get-serviceAccount.json": 64370,
	"./data/platform-ncl/get-storage-class.json": 97979,
	"./data/platform-ncl/get-storage-classes.json": 28844,
	"./data/platform-ncl/get-storage-performance.json": 32934,
	"./data/platform-ncl/get-svm-list.json": 21917,
	"./data/platform-ncl/get-svms-by-org.json": 29346,
	"./data/platform-ncl/get-svms-by-systems.json": 64709,
	"./data/platform-ncl/get-svms-filter-by-compliancePercent.json": 61856,
	"./data/platform-ncl/get-system-recommendations.json": 90885,
	"./data/platform-ncl/get-systems-by-org.json": 88971,
	"./data/platform-ncl/get-systems-filter-compliancePercent.json": 36221,
	"./data/platform-ncl/get-volumes-by-org-associated.json": 66949,
	"./data/platform-ncl/get-volumes-by-org.json": 2642,
	"./data/platform-ncl/get-volumes-filter-by-antiRansomware.json": 92286,
	"./data/platform-ncl/get-working-environments-relationship-status.json": 43191,
	"./data/platform-ncl/get-working-environments-status.json": 21077,
	"./data/platform-ncl/google-service-accounts-deployments-status.json": 24853,
	"./data/platform-ncl/google-service-accounts-deployments.json": 89172,
	"./data/platform-ncl/google-service-accounts-firewalls-post.json": 12047,
	"./data/platform-ncl/google-service-accounts-instances.json": 61798,
	"./data/platform-ncl/google-service-console-agents-configuration.json": 36728,
	"./data/platform-ncl/google-service-template-json.json": 44150,
	"./data/platform-ncl/health-status-timeseries.json": 22094,
	"./data/platform-ncl/homePage-capacity-used-timeseries-forecast.json": 42521,
	"./data/platform-ncl/homePage-capacity-used-timeseries-history.json": 37283,
	"./data/platform-ncl/homePage-top5-cluster-iops.json": 13715,
	"./data/platform-ncl/homePage-top5-cluster-latency.json": 59445,
	"./data/platform-ncl/homePage-top5-cluster-throughput.json": 22500,
	"./data/platform-ncl/igroups.json": 19767,
	"./data/platform-ncl/initiators.json": 22813,
	"./data/platform-ncl/iops-timeseries.json": 25061,
	"./data/platform-ncl/kms.json": 63500,
	"./data/platform-ncl/latency-timeseries.json": 1872,
	"./data/platform-ncl/license-summary.json": 69205,
	"./data/platform-ncl/licenses.json": 6616,
	"./data/platform-ncl/max-latency-overtime.json": 79188,
	"./data/platform-ncl/mfa-device-create.json": 32980,
	"./data/platform-ncl/mfa-devices.json": 51665,
	"./data/platform-ncl/mfa-oauth-token.json": 69463,
	"./data/platform-ncl/mfa-recovery-code-status.json": 49641,
	"./data/platform-ncl/mfa-recovery-code.json": 37120,
	"./data/platform-ncl/mfa-register.json": 64374,
	"./data/platform-ncl/mfa-user-config-status.json": 95092,
	"./data/platform-ncl/notification-config.json": 63785,
	"./data/platform-ncl/notification-messages.json": 72762,
	"./data/platform-ncl/notification-rule.json": 83585,
	"./data/platform-ncl/notification-rules.json": 20100,
	"./data/platform-ncl/notifications.json": 9195,
	"./data/platform-ncl/nss-keys.json": 82603,
	"./data/platform-ncl/occm-asup.json": 89072,
	"./data/platform-ncl/occm-config.json": 32325,
	"./data/platform-ncl/occm-instance-placement.json": 46652,
	"./data/platform-ncl/occmauth-api-users.json": 34291,
	"./data/platform-ncl/onbox-credentials.json": 4973,
	"./data/platform-ncl/onprem-aggregates.json": 16345,
	"./data/platform-ncl/onprem-cluster-info.json": 5357,
	"./data/platform-ncl/onprem-replication-status.json": 55242,
	"./data/platform-ncl/onprem-volumes.json": 76487,
	"./data/platform-ncl/onprem-working-environment-details.json": 12756,
	"./data/platform-ncl/org1-get.json": 42312,
	"./data/platform-ncl/organization-delete-users.json": 31412,
	"./data/platform-ncl/organization-summary.json": 46780,
	"./data/platform-ncl/orgs.json": 75612,
	"./data/platform-ncl/partnership-grant-resources.json": 58969,
	"./data/platform-ncl/partnership-grant-users.json": 98844,
	"./data/platform-ncl/partnership-grants.json": 66502,
	"./data/platform-ncl/partnership-organizations.json": 76046,
	"./data/platform-ncl/partnership-users.json": 96346,
	"./data/platform-ncl/partnership.json": 48557,
	"./data/platform-ncl/partnerships.json": 21770,
	"./data/platform-ncl/partnershiptypes.json": 40185,
	"./data/platform-ncl/performance-capacity-timeseries.json": 28574,
	"./data/platform-ncl/permissions.json": 79383,
	"./data/platform-ncl/permissions_full.json": 9762,
	"./data/platform-ncl/projects-resources-aws.json": 6843,
	"./data/platform-ncl/projects-resources-azure.json": 29464,
	"./data/platform-ncl/projects-resources-gcp.json": 93168,
	"./data/platform-ncl/projects-resources-keystone.json": 99971,
	"./data/platform-ncl/projects-resources-oci.json": 38395,
	"./data/platform-ncl/projects-resources-onprem.json": 37083,
	"./data/platform-ncl/projects-resources.json": 79392,
	"./data/platform-ncl/ransomware-status.json": 55776,
	"./data/platform-ncl/ransomware-summary.json": 4218,
	"./data/platform-ncl/recreate-client-secret.json": 2479,
	"./data/platform-ncl/registration-status.json": 95184,
	"./data/platform-ncl/resource-apac-get.json": 34346,
	"./data/platform-ncl/resource-org-get.json": 56338,
	"./data/platform-ncl/resource-utilization-aggr-forecast.json": 58070,
	"./data/platform-ncl/resource-utilization-aggr-history.json": 46726,
	"./data/platform-ncl/resource-utilization-node-forecast.json": 77864,
	"./data/platform-ncl/resource-utilization-node-history.json": 51431,
	"./data/platform-ncl/resources.json": 12985,
	"./data/platform-ncl/roles.json": 76812,
	"./data/platform-ncl/s3.json": 46659,
	"./data/platform-ncl/saas-mp-service.json": 85666,
	"./data/platform-ncl/security-dashboard-timeseries.json": 11074,
	"./data/platform-ncl/self-certificate.json": 84211,
	"./data/platform-ncl/settings-proxy.json": 98437,
	"./data/platform-ncl/signed-certificate.json": 40091,
	"./data/platform-ncl/smtp-config.json": 67131,
	"./data/platform-ncl/snapcenter_clusters.json": 67881,
	"./data/platform-ncl/snapshot-get.json": 70427,
	"./data/platform-ncl/storage-job-completed.json": 25094,
	"./data/platform-ncl/storageAccounts.json": 65194,
	"./data/platform-ncl/subscriptions.json": 48923,
	"./data/platform-ncl/support-services.json": 83729,
	"./data/platform-ncl/system-about.json": 93338,
	"./data/platform-ncl/tenancy-resources.json": 12888,
	"./data/platform-ncl/throughput-timeseries.json": 99158,
	"./data/platform-ncl/tiering.json": 4465,
	"./data/platform-ncl/uiroles.json": 76782,
	"./data/platform-ncl/user-details.json": 28421,
	"./data/platform-ncl/user-details_full.json": 64250,
	"./data/platform-ncl/user-login-tracking.json": 8654,
	"./data/platform-ncl/user-permissions-resources.json": 78433,
	"./data/platform-ncl/user-preferences-app-preferences.json": 1242,
	"./data/platform-ncl/user-preferences-splashscreen-v-1-dismissed.json": 18546,
	"./data/platform-ncl/user-resources-elevated-permissions.json": 90241,
	"./data/platform-ncl/user-resources-permissions.json": 29127,
	"./data/platform-ncl/users-filter-service-account.json": 4808,
	"./data/platform-ncl/users-filter-total-users.json": 82754,
	"./data/platform-ncl/users.json": 89376,
	"./data/platform-ncl/utilization-timeseries.json": 85258,
	"./data/platform-ncl/view-volume-details.json": 98599,
	"./data/platform-ncl/volume-avg-latency.json": 82262,
	"./data/platform-ncl/volume-dashboard-timeseries.json": 45176,
	"./data/platform-ncl/volume-other-latency.json": 24347,
	"./data/platform-ncl/volume-other-ops.json": 17557,
	"./data/platform-ncl/volume-read-data.json": 84262,
	"./data/platform-ncl/volume-read-latency.json": 10331,
	"./data/platform-ncl/volume-read-ops.json": 15966,
	"./data/platform-ncl/volume-total-data.json": 7387,
	"./data/platform-ncl/volume-total-ops.json": 72795,
	"./data/platform-ncl/volume-write-data.json": 95874,
	"./data/platform-ncl/volume-write-latency.json": 1490,
	"./data/platform-ncl/volume-write-ops.json": 76212,
	"./data/platform-ncl/webhook-configuration.json": 87770,
	"./data/platform-ncl/webhook-configurations.json": 9283,
	"./data/platform-ncl/working-environments-performance.json": 99404,
	"./data/platform-ncl/working-environments.json": 27808,
	"./data/platform-ncl/workload-analyzer-timeseries-available-forecast.json": 17700,
	"./data/platform-ncl/workload-analyzer-timeseries-available-history.json": 71525,
	"./data/platform-ncl/workload-analyzer-timeseries-snapshot-reserve-forecast.json": 5978,
	"./data/platform-ncl/workload-analyzer-timeseries-snapshot-reserve-history.json": 76395,
	"./data/platform-ncl/workload-analyzer-timeseries-snapshot-used-forecast.json": 80338,
	"./data/platform-ncl/workload-analyzer-timeseries-snapshot-used-history.json": 17475,
	"./data/platform-ncl/workload-analyzer-timeseries-used-forecast.json": 56679,
	"./data/platform-ncl/workload-analyzer-timeseries-used-history.json": 64030,
	"./data/platform/add-agent-azure.json": 49290,
	"./data/platform/add-agent-gcp.json": 98395,
	"./data/platform/add-federation.json": 1034,
	"./data/platform/add-pvtjwt-key.json": 29066,
	"./data/platform/add-service-account.json": 64712,
	"./data/platform/add-storage-class.json": 27706,
	"./data/platform/add-user.json": 64878,
	"./data/platform/add-volume-ncl.json": 10272,
	"./data/platform/agent-create-azure.json": 98854,
	"./data/platform/agent-create.json": 13660,
	"./data/platform/agent-status.json": 60692,
	"./data/platform/agent-tls-certificate.json": 17781,
	"./data/platform/ai-config-id.json": 30997,
	"./data/platform/ai-config-save.json": 17079,
	"./data/platform/ai-config.json": 69866,
	"./data/platform/ai-provider-models.json": 11187,
	"./data/platform/ai-supported-models.json": 15174,
	"./data/platform/ai-supported-providers.json": 8245,
	"./data/platform/alert-detail.json": 94726,
	"./data/platform/alert-summary.json": 60206,
	"./data/platform/alert-trends.json": 60762,
	"./data/platform/alerts-agents.json": 62744,
	"./data/platform/alerts-list.json": 20689,
	"./data/platform/alerts-related.json": 8732,
	"./data/platform/all-relationships.json": 91906,
	"./data/platform/audit-options.json": 38775,
	"./data/platform/audit.json": 90337,
	"./data/platform/available-update-versions.json": 32993,
	"./data/platform/aws-assume-role.json": 4399,
	"./data/platform/aws-role-sessions-status.json": 46675,
	"./data/platform/aws-role-sessions.json": 68213,
	"./data/platform/azure-service-principal-post.json": 58071,
	"./data/platform/back-up-and-recovery-summary.json": 13295,
	"./data/platform/billing-preferences.json": 45750,
	"./data/platform/by-capacity-byol-details-v2.json": 85792,
	"./data/platform/case-search.json": 67828,
	"./data/platform/cbs_we_replication.json": 86602,
	"./data/platform/cbs_we_status.json": 38975,
	"./data/platform/change-cvo-package-options.json": 12153,
	"./data/platform/cifs.json": 95416,
	"./data/platform/cloud-compliance-compliance-status.json": 49515,
	"./data/platform/cloud-compliance-status.json": 70590,
	"./data/platform/cloud-providers.json": 41230,
	"./data/platform/cloud-storage.json": 27668,
	"./data/platform/cloud-sync-relationships-stats.json": 41638,
	"./data/platform/cloudmanager_cbs-v1-relationships.json": 119,
	"./data/platform/clusterRecommendation.json": 96626,
	"./data/platform/connector-about.json": 27235,
	"./data/platform/connectors.json": 30930,
	"./data/platform/console-agents-configuration.json": 88263,
	"./data/platform/create-folder.json": 51090,
	"./data/platform/create-project.json": 55646,
	"./data/platform/credential.json": 2682,
	"./data/platform/credentials.json": 77216,
	"./data/platform/cvs-azure-accounts.json": 69947,
	"./data/platform/discover-fsx.json": 18539,
	"./data/platform/discover-on-prem.json": 66271,
	"./data/platform/dw-associated-accounts.json": 54161,
	"./data/platform/dw-associated-subscriptions.json": 78285,
	"./data/platform/external-licenses.json": 74142,
	"./data/platform/feature-rollouts.json": 60215,
	"./data/platform/federation-domains-patch.json": 13822,
	"./data/platform/federation-domains-post.json": 8789,
	"./data/platform/federation-domains.json": 83806,
	"./data/platform/federation-federations.json": 85224,
	"./data/platform/federation-test-connection.json": 71386,
	"./data/platform/federation-unmigratedconnections.json": 70058,
	"./data/platform/filter-audit-action-add-credentials.json": 3907,
	"./data/platform/filter-audit-action-update-license-by-serial.json": 48093,
	"./data/platform/filter-audit-action-update-we-snapMirror-policies.json": 91500,
	"./data/platform/filter-audit-no-agent.json": 33928,
	"./data/platform/filter-audit-service-console.json": 59194,
	"./data/platform/filter-audit-service-credentials.json": 63857,
	"./data/platform/filter-audit-service-digitalwallet.json": 21666,
	"./data/platform/filter-audit-status-failed.json": 1864,
	"./data/platform/filter-audit-status-success.json": 68954,
	"./data/platform/filter-audit-user-bill.json": 79907,
	"./data/platform/filter-audit-user-sam.json": 41702,
	"./data/platform/filter-backup-licenses.json": 31996,
	"./data/platform/filter-dr-licenses.json": 76807,
	"./data/platform/filter-include-exchanged-licenses.json": 72411,
	"./data/platform/filter-org-resources-count.json": 34910,
	"./data/platform/filter-org-users.json": 61216,
	"./data/platform/filter-rsp-licenses.json": 12408,
	"./data/platform/filter-tiering-licenses.json": 35401,
	"./data/platform/folder-resources-get.json": 58349,
	"./data/platform/gcp-agent-create.json": 5189,
	"./data/platform/gcp-config-deployment.json": 38422,
	"./data/platform/gcp-config-operation-status.json": 63449,
	"./data/platform/gcp-storage-buckets.json": 96539,
	"./data/platform/gcp-storage-upload-object.json": 17341,
	"./data/platform/get-agent.json": 38175,
	"./data/platform/get-capacity-policies.json": 28241,
	"./data/platform/get-export-policies.json": 29555,
	"./data/platform/get-igroups.json": 83554,
	"./data/platform/get-initiators.json": 53403,
	"./data/platform/get-os-types.json": 6310,
	"./data/platform/get-performance-policies.json": 76116,
	"./data/platform/get-protection-policies.json": 37431,
	"./data/platform/get-pvtjwt-keys.json": 14450,
	"./data/platform/get-security-policies.json": 99714,
	"./data/platform/get-serviceAccount.json": 75435,
	"./data/platform/get-storage-class.json": 16393,
	"./data/platform/get-storage-classes.json": 25082,
	"./data/platform/get-storage-performance.json": 69391,
	"./data/platform/get-system-recommendations.json": 54315,
	"./data/platform/get-working-environments-relationship-status.json": 49549,
	"./data/platform/get-working-environments-status.json": 8741,
	"./data/platform/google-service-accounts-deployments-status.json": 72040,
	"./data/platform/google-service-accounts-deployments.json": 99179,
	"./data/platform/google-service-accounts-firewalls-post.json": 97017,
	"./data/platform/google-service-accounts-instances.json": 39913,
	"./data/platform/google-service-console-agents-configuration.json": 10171,
	"./data/platform/google-service-template-json.json": 45318,
	"./data/platform/igroups.json": 50452,
	"./data/platform/initiators.json": 66526,
	"./data/platform/kms-us-east-2.json": 37229,
	"./data/platform/kms-us-west-1.json": 75221,
	"./data/platform/kms.json": 45631,
	"./data/platform/license-summary.json": 87234,
	"./data/platform/licenses.json": 50824,
	"./data/platform/marketplace-context.json": 59938,
	"./data/platform/notification-config.json": 49894,
	"./data/platform/notification-messages.json": 58473,
	"./data/platform/notifications.json": 576,
	"./data/platform/nss-keys.json": 29903,
	"./data/platform/occm-asup.json": 18456,
	"./data/platform/occm-config.json": 44251,
	"./data/platform/occm-instance-placement.json": 88927,
	"./data/platform/occmauth-api-users.json": 76546,
	"./data/platform/onbox-credentials.json": 28138,
	"./data/platform/onprem-aggregates.json": 4972,
	"./data/platform/onprem-cluster-info.json": 40639,
	"./data/platform/onprem-replication-status.json": 88153,
	"./data/platform/onprem-volumes.json": 19463,
	"./data/platform/onprem-working-environment-details.json": 90,
	"./data/platform/org1-get.json": 14670,
	"./data/platform/organization-delete-users.json": 92781,
	"./data/platform/organization-summary.json": 41256,
	"./data/platform/orgs.json": 22357,
	"./data/platform/partnership-grant-resources.json": 13682,
	"./data/platform/partnership-grant-users.json": 94247,
	"./data/platform/partnership-grants.json": 59050,
	"./data/platform/partnership-organizations.json": 15220,
	"./data/platform/partnership-users.json": 38847,
	"./data/platform/partnership.json": 86259,
	"./data/platform/partnerships.json": 65320,
	"./data/platform/partnershiptypes.json": 55472,
	"./data/platform/permissions.json": 53181,
	"./data/platform/permissions_full.json": 20079,
	"./data/platform/projects-resources-aws.json": 32577,
	"./data/platform/projects-resources-azure.json": 88146,
	"./data/platform/projects-resources-gcp.json": 49361,
	"./data/platform/projects-resources-keystone.json": 71122,
	"./data/platform/projects-resources-oci.json": 4087,
	"./data/platform/projects-resources-onprem.json": 30756,
	"./data/platform/projects-resources.json": 12051,
	"./data/platform/ransomware-status.json": 87306,
	"./data/platform/ransomware-summary.json": 42801,
	"./data/platform/registration-status.json": 23975,
	"./data/platform/resolve-aws-subscription.json": 97779,
	"./data/platform/resolve-azure-subscription.json": 96269,
	"./data/platform/resource-apac-get.json": 46172,
	"./data/platform/resource-org-get.json": 20531,
	"./data/platform/resources.json": 73799,
	"./data/platform/resourcetypes.json": 9925,
	"./data/platform/roles.json": 41865,
	"./data/platform/s3.json": 42167,
	"./data/platform/saas-mp-service.json": 77020,
	"./data/platform/self-certificate.json": 77369,
	"./data/platform/settings-proxy.json": 91029,
	"./data/platform/signed-certificate.json": 3312,
	"./data/platform/snapcenter_clusters.json": 93635,
	"./data/platform/snapshot-get.json": 19861,
	"./data/platform/storage-job-completed.json": 36307,
	"./data/platform/storageAccounts.json": 69838,
	"./data/platform/subscriptions.json": 22763,
	"./data/platform/support-services.json": 39837,
	"./data/platform/system-about.json": 5478,
	"./data/platform/tenancy-resources.json": 7571,
	"./data/platform/tiering.json": 49712,
	"./data/platform/uiroles.json": 92590,
	"./data/platform/user-details-partner-org1.json": 67120,
	"./data/platform/user-details.json": 73650,
	"./data/platform/user-details_full.json": 69378,
	"./data/platform/user-details_org2.json": 19930,
	"./data/platform/user-login-tracking.json": 94318,
	"./data/platform/user-permissions-resources.json": 21459,
	"./data/platform/user-preferences-app-preferences.json": 19900,
	"./data/platform/user-preferences-splashscreen-v-1-dismissed.json": 86933,
	"./data/platform/user-resources-elevated-permissions.json": 71133,
	"./data/platform/user-resources-permissions.json": 31366,
	"./data/platform/usergroups-federated.json": 61998,
	"./data/platform/users-filter-service-account.json": 21266,
	"./data/platform/users-filter-total-users.json": 27021,
	"./data/platform/users.json": 21075,
	"./data/platform/view-volume-details.json": 72458,
	"./data/platform/working-environments-performance.json": 32874,
	"./data/platform/working-environments.json": 34262
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44574;